module.exports = __webpack_public_path__ + "static/media/00_quadcopter_positioning_card.52e73385.png";